import React, { useState, useCallback, useEffect } from 'react'
import ReactResponsiveModal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Input } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createStagesStudy, updateStagesStudy } from '../../actions/stagesStudy'
import styles from './styles.module.css'
import Confirmation from '../../components/Confirmation/Confirmation'

const validationSchema = Yup.object({
  name: Yup.string().required('Заполните название').max(30, 'Должно быть не более 30 символов'),
})

export default function StagesStudyModal({ data, closeModal }) {
  const dispatch = useDispatch()

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const addMode = !data?.f_studysteps

  const getInitialValues = (data) => addMode ? { name: '' } : { ...data }

  const handleCreate = (values) => {
    dispatch(createStagesStudy(values, closeModal))
  }

  const handleUpdate = (values) => {
    dispatch(updateStagesStudy(values, closeModal))
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    resetForm
  } = useFormik({
    initialValues: getInitialValues(data),
    validationSchema,
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (data) resetForm({ values: getInitialValues(data) })
  }, [data])

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    <ReactResponsiveModal
      open={!!data}
      onClose={handleClose}
      showCloseIcon={false}
      closeOnOverlayClick={true}
      closeOnEsc={true}
      center
      classNames={{
        modal: styles.modal,
        modalContainer: styles.modalContainer
      }}
    >
      <>
        <div className={styles.modalMain}>
          <h2>{addMode ? 'Добавление ступени обучения' : 'Редактирование ступени обучения'}</h2>

          <div className={styles.inputsColumn}>
            <Input
              label='Название'
              placeholder='до 30 символов'
              name='name'
              value={values.name}
              error={error('name')}
              onChange={handleChange}
              maxLength='30'
              labelStyle={{ width: '100%', maxWidth: '100%' }}
            />
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
        {confirmClose && (
          <Confirmation
            title="Закрыть без сохранения изменений?"
            acceptConfirmation={acceptConfirmation}
            rejectConfirmation={rejectConfirmation}
          />
        )}
      </>
    </ReactResponsiveModal>
  )
}
